/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react'
import { Modal, Button } from 'rsuite';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { DarkModeContext } from '~/common/contexts/darkMode';
import PropTypes from 'prop-types';
import { ButtonFullBlue } from '~/components/Buttons/ButtonFullBlue/styles';
import { ButtonBorderBlue } from '~/components/Buttons/ButtonBorderBlue/styles';


const ModalEnviarNotificacaoSemConta = ({ filtroData, textoDigitado, statusFiltro, atributoSelecionado }) => {
    const [exibir, setExibir] = useState(false);
    const { toggleMode } = useContext(DarkModeContext)
    const loggeduser = useSelector((state) => state.setUser.data);


    async function enviarNotificacao() {

        if (!filtroData || filtroData.length === 0) {
            return toast.error('É necessário selecionar uma data')
        }

        try {
            const enviarNot = await api.post('/notificacao/notificacao-profissonais-semconta', {
                    datas: filtroData,
                    [atributoSelecionado]: textoDigitado,
                    status: statusFiltro,
            })
            toast.success(enviarNot.data.message)

            setExibir(false)
        } catch (error) {
            console.log(error)
            toast.error(error.message);
        }

    }

    return (
        <>
            <ButtonBorderBlue appearance="ghost" onClick={() => setExibir(true)} darkMode={toggleMode} >
                Enviar Notificação
            </ButtonBorderBlue>
            <Modal open={exibir} onClose={() => setExibir(false)} size="sm">
                <Modal.Header>
                    <Modal.Title>Enviar Notificação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>Enviar Notificação para todos os profissonais sem pix ou conta com estes filtros?</h5>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setExibir(false)} appearance="subtle">
                        Cancelar
                    </Button>
                    <ButtonFullBlue
                        appearance="primary"
                        onClick={() => enviarNotificacao()}
                    >
                        Enviar
                    </ButtonFullBlue>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalEnviarNotificacaoSemConta